export default __webpack_public_path__ + "static/media/link.86375237.svg";